"use client"

import { useAuth } from "@/context/AuthContext"
import { Wordmark } from "@/components/layout/wordmark"
import { HeaderUI, type HeaderLink } from "./header-ui"

const links: HeaderLink[] = [
  { label: "Pricing", href: "/pricing" },
]

// The one public-marketing-page header — reads the shared AuthContext for
// signed-in state and delegates sign-out to the single canonical
// implementation (AuthContext.signOut), rather than each header having its
// own copy of the Supabase sign-out call.
export function SiteHeader() {
  const { user, signOut } = useAuth()

  return (
    <HeaderUI
      layout="simple"
      logo={<Wordmark />}
      links={links}
      isSignedIn={!!user}
      email={user?.email ?? null}
      showPricingLink
      onSignOut={signOut}
    />
  )
}
